import { gql } from '@apollo/client'

export const GET_VIP_MEMBER = gql`
  query getVipMember {
    accountModule {
      copyrightMember {
        type
        memberDetail {
          startTime
          endTime
          hold
        }
        memberRight {
          icon
          name
          desc
        }
        sellList {
          price
          num
        }
      }
    }
  }
`

export const GET_VIP_MEMBER_ORDERS = gql`
  query getVipMemberOrders(
    $offset: Int = 0
    $first: Int = 20
    $param: MemberCardBillQueryInput
  ) {
    accountModule {
      memberCardBillList(
        page: { first: $first, offset: $offset }
        input: $param
      ) {
        edges {
          node {
            cycleCount
            expireTime
            orderNo
            startTime
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  }
`

export const GET_VIP_MEMBER_ORDER_DETAIL = gql`
  query getVipMemberOrderDetail($orderNo: String) {
    orderModule {
      copyrightRechargeOrder(orderNo: $orderNo) {
        createTime
        orderNo
        payChannel
        payTime
        totalFee
      }
    }
    accountModule {
      userMemberCardBill(orderNo: $orderNo) {
        cycleCount
        expireTime
        startTime
      }
    }
  }
`
